import { useCallback, useState } from "react";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { useNavigate, useParams } from "react-router";
import { processError } from "../../../../common/utils/base_error";
import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import {
  ProjetoForm,
  ProjetoSchema,
} from "../schemas/Projetos_cadastro/Projetos_cadastro";
import { useAnexarDocumentosPagination } from "../hooks/Projetos_Arquivo/pagination";
import {
  AnexarDocumentosForm,
  AnexarDocumentosSchema,
} from "../schemas/Projetos_cadastro/Anexar_Documentos";
import { downloadBase64File } from "../../../../common/utils/download_utils";
import { useInformacoesProjetoPagination } from "../hooks/Projeto_Informacao/pagination";
import {
  ProjetoInformacoesForm,
  ProjetoInformacoesSchema,
} from "../schemas/Projetos_cadastro/Projeto_Informacoes";
import {
  initialInformacoesFiltersState,
  useFiltersInformacoes,
} from "../hooks/Projeto_Informacao/filter";
import { evaluateParamValue } from "../../../../common/utils/params_utils";
import {
  useCreateDebounceHandler,
  useDebouncedCallback,
} from "../../../../common/hooks/use_debounced_callback";
import { useProjetosDisciplinaPagination } from "../hooks/Projetos_Disciplina/pagination";
import {
  initialDisciplinasFiltersState,
  useFiltersDisciplinas,
} from "../hooks/Projetos_Disciplina/filter";
import {
  DisciplinaRequestForm,
  DisciplinaRequestSchema,
} from "../schemas/Projetos_cadastro/Disciplina_e_SubDisciplina";
import { GetDropDownChecklistResponse } from "../../data/daos/read/get_drop_down_checklist";
import { GetDropDownDisciplinaResponse } from "../../data/daos/read/get_drop_down_disciplina";
import { useFiltersDisciplinasArquivos } from "../hooks/Projetos_Disciplina_Arquivo/filter";
import { useProjetosDisciplinaArquivosPagination } from "../hooks/Projetos_Disciplina_Arquivo/pagination";
import { GetAllDisciplinasArquivosDaoModel } from "../../domain/models/disciplina_arquivo_models";
import {
  DisciplinaArquivoForm,
  DisciplinaArquivoSchema,
} from "../schemas/Projetos_cadastro/Disciplina_Arquivos";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ProjetoLista } from "../../domain/models/projetos_Lista";
import { DocumentoLista } from "../../domain/models/documentos_lista";
import { LogTipoTabela } from "../../../../common/utils/log_tabela_tipo";
import { useChangeHistory } from "../../../../common/hooks/use_change_history";
import { uploadFileToBase64String } from "../../../../common/utils/utils";
import { InformacoesLista } from "../../domain/models/informacoes_lista";
import { DisciplinaLista } from "../../domain/models/disciplina_lista";
import {
  ProjetoRevisaoResumoForm,
  ProjetoRevisaoResumoSchema,
} from "../schemas/Projetos_cadastro/projeto_revisao";
import { ProjetoRevisaoResumoLista } from "../../domain/models/revisao_projeto_resumo_lista";
import { useProjetoRevisaoResumoPagination } from "../hooks/Projetos_revisao_resumo/pagination";
import { GetProjetoDisciplinaByIdResponseModel } from "../../domain/models/disciplina_models";
import { DisciplinaCopiaRequestForm } from "../schemas/Projetos_cadastro/Disciplina_e_SubDisciplina_copia";
import { useReportViewer } from "../../../../config/hooks/utils/report_viewer";

type LoadProjetoFuncState = {
  IdProjeto?: number;
};
type LoadAnexarDocumentosFuncState = {
  IdProjeto?: number | null;
  Page?: number;
  RowsPerPage?: number;
};
type LoadRevisaoFuncState = {
  IdProjeto?: number | null;
  idDisciplina?: number | null;
  Page?: number;
  RowsPerPage?: number;
};

type LoadInformacoesPorjetoFuncState = {
  IdProjeto?: number | null;
  Data?: Date | null;
  Informacoes?: string | null;
  Page?: number | null;
  RowsPerPage?: number | null;
};

export interface LoadProjetoDisciplinasFuncState {
  Disciplina?: string | null;
  Prancha?: string | null;
  Revisao?: string | null;
  Por?: string | null;

  IdProjeto?: number;
  Page?: number;
  RowsPerPage?: number;
}

export interface LoadProjetoArquivosFuncState {
  Disciplina?: string | null;
  Prancha?: string | null;
  Revisao?: string | null;
  Por?: string | null;

  IdProjeto?: number;
  Page?: number;
  RowsPerPage?: number;
}

export const useProjetoCadastroViewModel = () => {
  const {
    commons: { getAllLogAlteracaoUseCase, getAllLogAlteracaoByParentUseCase },
    reports: { getReportListaDisciplinasUseCase, getReportPlanoProjetoUseCase },
    projetos: {
      getProjetoByIdUseCase,
      createProjetoUseCase,
      updateProjetoUseCase,

      getAllProjetoArquivoUseCase,
      createProjetoArquivoUseCase,
      updateProjetoArquivoUseCase,
      getProjetoArquivoByIdUseCase,
      deleteProjetoArquivoUseCase,

      getAllProjetoInformacoesUseCase,
      createProjetoInformacoesUseCase,
      updateProjetoInformacoesUseCase,
      deleteProjetoInformacoesUseCase,

      getAllProjetoDisciplinaUseCase,
      copiaDisciplinasUseCase,
      createProjetoDisciplinaUseCase,
      updateProjetoDisciplinaUseCase,
      deleteProjetoDisciplinaUseCase,
      getProjetoDisciplinaByIdUseCase,
      deleteDisciplinaChecklistUseCase,

      dropDownChecklistUseCase,
      dropDownDisciplinaUseCase,

      getDisciplinasArquivosByIdUseCase,
      deleteDisciplinasArquivosUseCase,
      getAllDisciplinasArquivosUseCase,
      updateDisciplinasArquivosUseCase,
      getArqDisciplinasArquivosUseCase,

      getAllProjetoRevisaoResumoUseCase,
      createProjetoRevisaoResumoUseCase,
      updateProjetoRevisaoResumoUseCase,
      deleteProjetoRevisaoResumoUseCase,
    },
  } = useDependencyInjection();
  const { id, tab } = useParams();
  const navigate = useNavigate();

  const changeHistory = useChangeHistory({
    getAllLogAlteracaoByParentUseCase: getAllLogAlteracaoByParentUseCase,
    getAllLogAlteracaoUseCase: getAllLogAlteracaoUseCase,
    onSetError: (e) => pushErrorNotification("Erro", [e]),
  });

  const [currentTab, setCurrentTab] = useState(1);
  const [errorMessage, setErrorMessage] = useState<string>();

  const [loading, setLoading] = useState(false);
  const {
    pushErrorNotification,
    pushInfoNotification,
    pushWarnNotification,
    setCustomLoading,
  } = usePageLoader();

  //#region Relatorio
  const [reportViewerState, startReportViewerProcess] = useReportViewer();
  //#endregion

  //#region Projeto
  const hookForm = useForm<ProjetoForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(ProjetoSchema),
  });

  const [idProjeto, setIdProjeto] = useState<number>(0);

  const [selectedProjeto, setSelectedProjeto] = useState<ProjetoLista>();
  //#endregion
  const [IdDisciplinaArquivos, setIdDisciplinaArquivos] = useState<
    number | null
  >(null);

  //#region  Documento
  const hookFormDocumento = useForm<AnexarDocumentosForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(AnexarDocumentosSchema),
  });
  const [selectedDocumento, setSelectedDocumento] =
    useState<DocumentoLista | null>(null);
  const [openModalDocumentos, setOpenModalDocumentos] = useState(false);
  const [openDeleteArquivoModal, setOpenDeleteArquivoModal] =
    useState<boolean>(false);
  const [limparArquivo, setLimparArquivo] = useState<string>();
  const [arquivo, setArquivo] = useState<string>();
  const paginationAnexarDocumentos = useAnexarDocumentosPagination();
  const [arquivosLista, setArquivosLista] = useState<DocumentoLista[]>([]);
  const [openDeleteModalDoc, setOpenDeleteModalDoc] = useState<boolean>(false);

  //#endregion

  //#region  Informacoes
  const hookFormInformacoes = useForm<ProjetoInformacoesForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(ProjetoInformacoesSchema),
  });
  const [nomeCentroCusto, setNomeCentroCusto] = useState<string>("");

  const [openModalInfor, setOpenModalInfor] = useState<boolean>(false);
  const [informacoesLista, setInformacoesLista] = useState<InformacoesLista[]>(
    [],
  );
  const filtersInformacoes = useFiltersInformacoes();
  const paginationInformacoes = useInformacoesProjetoPagination();
  const [selectedInfo, setSelectedInfo] = useState<InformacoesLista | null>(
    null,
  );
  const [openDeleteModalInfor, setOpenDeleteModalInfor] =
    useState<boolean>(false);
  //#endregion

  //#region  Disciplina
  const hookFormDisciplina = useForm<DisciplinaRequestForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(DisciplinaRequestSchema),
  });
  const [openCopiaModal, setOpenCopiaModal] = useState<boolean>(false);
  const [disciplinasLista, setDisciplinasLista] = useState<DisciplinaLista[]>(
    [],
  );
  const [selectedtDisciplina, setSelectedtDisciplina] =
    useState<GetProjetoDisciplinaByIdResponseModel | null>(null);
  const [dadosEditDisciplinaArquivo, setDadosEditDisciplinaArquivo] =
    useState<DisciplinaArquivoForm | null>(null);
  const [openRemoveModalDisciplinaCheck, setOpenRemoveModalDisciplinaCheck] =
    useState(false);
  const filterDisciplina = useFiltersDisciplinas();
  const filterDisciplinaArquivos = useFiltersDisciplinasArquivos();
  const [openModalDisciplina, setOpenModaDisciplina] = useState(false);
  const [IdDisciplina, setIdDisciplina] = useState<number>(0);
  const [definirModelSubDisciplina, setDefinirModelSubDisciplina] =
    useState<boolean>(false);
  const [selectedIdDisciplinaCheck, setSelectedIdDisciplinaCheck] =
    useState<number>();
  //#endregion

  //#region Revisao
  const hookFormRevisao = useForm<ProjetoRevisaoResumoForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(ProjetoRevisaoResumoSchema),
  });
  const [openModalRevisao, setOpenModalRevisao] = useState(false);
  const [selectedRevisao, setSelectedRevisao] =
    useState<ProjetoRevisaoResumoLista>();
  const [revisaoLista, setRevisaoLista] = useState<ProjetoRevisaoResumoLista[]>(
    [],
  );
  const [openDeleteModalRevisao, setOpenDeleteModalRevisao] =
    useState<boolean>(false);
  const paginationResumo = useProjetoRevisaoResumoPagination();

  //#endregion

  // const [editmoddisciplina, seteditmoddisciplina] = useState(false);
  const [saving, setSaving] = useState(false);
  const paginationDisciplinasProjeto = useProjetosDisciplinaPagination();
  const paginationDisciplinasArquivosProjeto =
    useProjetosDisciplinaArquivosPagination();
  const [dropDownChecklist, setDropDownChecklist] = useState<
    GetDropDownChecklistResponse[]
  >([]);
  const [dropDownDisciplina, setDropDownDisciplina] = useState<
    GetDropDownDisciplinaResponse[]
  >([]);

  const [openDeleteModalDisciplina, setOpenDeleteModalDisciplina] =
    useState(false);
  const [
    openDeleteModalDisciplinaArquivo,
    setOpenDeleteModalDisciplinaArquivo,
  ] = useState(false);

  const debouncedLoad = useCreateDebounceHandler(750);
  const [disciplinasListaArquivos, setDisciplinasListaArquivos] = useState<
    GetAllDisciplinasArquivosDaoModel[]
  >([]);

  const [abrirModalDisciplinaArquivo, setOpenModaDisciplinaArquivo] =
    useState<boolean>(false);

  const hookFormDisciplinaArquivo = useForm<DisciplinaArquivoForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(DisciplinaArquivoSchema),
  });

  //#region Projeto

  //#region CARREGAMENTO

  const LoadProjeto = useCallback(
    async (funcState?: LoadProjetoFuncState) => {
      setLoading(true);
      const filterId = funcState?.IdProjeto;

      try {
        if (filterId) {
          const response = await getProjetoByIdUseCase.getProjetoById(
            Number(id),
          );
          setSelectedProjeto(response);
          setNomeCentroCusto(response.CentroCustoNome ?? "");
          hookForm.reset({
            idProjeto: response.IdProjeto,
            idNovoNegocio: response.IdNovoNegocio,
            idCentroCusto: response.IdCentroCusto,
            descricaoProjeto: response.DescricaoProjeto ?? "",
            numeroContrato: response.NumeroContrato,

            contato: response.Contato,
            telefoneCelular: response.TelefoneCelular,
            telefoneFixo: response.TelefoneFixo,
            email: response.Email,

            contato1: response.Contato1,
            telefone1: response.Telefone1,
            email1: response.Email1,

            contato2: response.Contato2,
            telefone2: response.Telefone2,
            email2: response.Email2,

            escopo: response.Escopo,
            dadosEntrada: response.DadosEntrada,
            informacoes: response.Informacoes,
            responsavel: response.Responsavel,

            data: response.Data,
            dataInicio: response.DataInicio,
            dataTermino: response.DataTermino,
            dataInicioreal: response.DataInicioReal,
            dataTerminoreal: response.DataTerminoReal,

            // arquivo: response.Arquivo,
            // nomeArquivo: response.NomeArquivo,
          });
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar projeto!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [getProjetoByIdUseCase, hookForm, id, pushErrorNotification],
  );
  const loadDropDownChecklist = useCallback(async () => {
    try {
      const dropDown = await dropDownChecklistUseCase.dropDownChecklist({});
      setDropDownChecklist(dropDown ?? []);
    } catch (e: unknown) {
      throw e;
    }
  }, [setDropDownChecklist, dropDownChecklistUseCase]);

  const loadDropDownDisciplina = useCallback(
    async (id: number) => {
      try {
        const dropDown = await dropDownDisciplinaUseCase.dropDownDisciplina({
          id: id ?? idProjeto,
        });
        setDropDownDisciplina(dropDown ?? []);
      } catch (e: unknown) {
        throw e;
      }
    },
    [setDropDownDisciplina, dropDownDisciplinaUseCase, idProjeto],
  );

  //#endregion

  //#region Evento

  const handleProjetoSubmit = useCallback(
    async (form: ProjetoForm) => {
      try {
        setSaving(true);
        if (!form.descricaoProjeto)
          return pushWarnNotification(
            "Atenção",
            "Forneça uma descrição clara do projeto.",
          );
        if (idProjeto) {
          await updateProjetoUseCase.updateProjeto(
            idProjeto,
            form.descricaoProjeto ?? null,
            form.numeroContrato ?? null,
            form.idCentroCusto ?? null,

            form.dataInicio ?? null,
            form.dataTermino ?? null,
            form.dataInicioreal ?? null,
            form.dataTerminoreal ?? null,

            form.contato1 ?? null,
            form.telefone1 ?? null,
            form.email1 ?? null,

            form.contato2 ?? null,
            form.telefone2 ?? null,
            form.email2 ?? null,

            form.escopo ?? null,
            form.dadosEntrada ?? null,
          );
          pushInfoNotification("Sucesso", "Projeto atualizado com sucesso!", {
            isAutoFinish: true,
          });
        } else {
          const retorno = await createProjetoUseCase.createProjeto(
            form.descricaoProjeto ?? null,
            form.numeroContrato ?? null,
            form.idCentroCusto ?? null,

            form.dataInicio ?? null,
            form.dataTermino ?? null,
            form.dataInicioreal ?? null,
            form.dataTerminoreal ?? null,

            form.contato1 ?? null,
            form.telefone1 ?? null,
            form.email1 ?? null,

            form.contato2 ?? null,
            form.telefone2 ?? null,
            form.email2 ?? null,

            form.escopo ?? null,
            form.dadosEntrada ?? null,
          );
          setIdProjeto(retorno);
          await loadDropDownChecklist();
          pushInfoNotification("Sucesso", "Projeto criado com sucesso!");
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar projeto!"),
        );
      } finally {
        setSaving(false);
      }
    },
    [
      pushWarnNotification,
      idProjeto,
      updateProjetoUseCase,
      pushInfoNotification,
      createProjetoUseCase,
      loadDropDownChecklist,
      pushErrorNotification,
    ],
  );
  //#endregion

  //#endregion

  //#region Load Arquivos

  const loadfilterDisciplinaArquivos = useCallback(
    async (funcState?: LoadProjetoArquivosFuncState) => {
      try {
        const filterDisciplinas = evaluateParamValue(
          funcState?.Disciplina,
          filterDisciplinaArquivos.disciplina,
        );
        const filterPrancha = evaluateParamValue(
          funcState?.Prancha,
          filterDisciplinaArquivos.prancha,
        );
        const filterRevisao = evaluateParamValue(
          funcState?.Revisao,
          filterDisciplinaArquivos.revisao,
        );
        const filterPor = evaluateParamValue(
          funcState?.Por,
          filterDisciplinaArquivos.por,
        );

        const filterIdProjeto = funcState?.IdProjeto ?? idProjeto;
        const filterPage =
          funcState?.Page ?? paginationDisciplinasArquivosProjeto.page;
        const filterRowsPage =
          funcState?.RowsPerPage ??
          paginationDisciplinasArquivosProjeto.rowsPerPage;

        await getAllDisciplinasArquivosUseCase.getAllDisciplinasArquivos({
          idProjeto: filterIdProjeto,
          por: filterPor ?? "T",
          disciplina: filterDisciplinas ?? undefined,
          prancha: filterPrancha ?? undefined,
          revisao: filterRevisao ?? undefined,
          page: filterPage,
          rowsPerPage: filterRowsPage,
        });

        setDisciplinasListaArquivos(getAllDisciplinasArquivosUseCase.items);
        paginationDisciplinasArquivosProjeto.setRowsPerPage(
          getAllDisciplinasArquivosUseCase.pageSize,
        );
        paginationDisciplinasArquivosProjeto.setTotalItems(
          getAllDisciplinasArquivosUseCase.totalItems,
        );
      } catch (e: unknown) {
        setDisciplinasListaArquivos([]);
        throw new Error("Falha ao buscar disciplinas do projeto!");
      }
    },
    [
      paginationDisciplinasArquivosProjeto,
      getAllDisciplinasArquivosUseCase,
      setDisciplinasListaArquivos,
      idProjeto,
      filterDisciplinaArquivos,
    ],
  );

  //#endregion

  //#region Anexar Documentos

  //#region Load
  const loadAnexarDocumentos = useCallback(
    async (funcState?: LoadAnexarDocumentosFuncState) => {
      try {
        const filterIdProjeto = funcState?.IdProjeto ?? idProjeto;
        const filterpage = funcState?.Page ?? paginationAnexarDocumentos.page;
        const filterRowspage =
          funcState?.RowsPerPage ?? paginationAnexarDocumentos.rowsPerPage;

        await getAllProjetoArquivoUseCase.getAllProjetoArquivo(
          filterIdProjeto,
          filterpage,
          filterRowspage,
        );

        setArquivosLista(getAllProjetoArquivoUseCase.items);
        paginationAnexarDocumentos.setRowsPerPage(
          getAllProjetoArquivoUseCase.pageSize,
        );
        paginationAnexarDocumentos.setTotalItems(
          getAllProjetoArquivoUseCase.totalItems,
        );
      } catch (e: unknown) {
        setArquivosLista([]);
        throw new Error("Falha ao buscar documentos!");
      }
    },
    [
      paginationAnexarDocumentos,
      getAllProjetoArquivoUseCase,
      setArquivosLista,
      idProjeto,
    ],
  );

  //#endregion

  //#region Eventos

  const handleaDocumentoSubmit = useCallback(
    async (form: AnexarDocumentosForm) => {
      try {
        setSaving(true);
        if (selectedDocumento) {
          await updateProjetoArquivoUseCase.updateProjetoArquivo(
            form.idProjetoArquivo ?? 0,
            idProjeto,
            form.descricao ?? null,
            form.nome ?? null,
            form.arquivo ?? null,
          );
        } else {
          await createProjetoArquivoUseCase.createProjetoArquivo(
            idProjeto,
            form.descricao ?? null,
            form.nome ?? null,
            form.arquivo ?? null,
          );
        }
        setOpenModalDocumentos(false);
        await loadAnexarDocumentos();
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar documentos!"),
        );
      } finally {
        setSaving(false);
      }
    },
    [
      selectedDocumento,
      loadAnexarDocumentos,
      updateProjetoArquivoUseCase,
      idProjeto,
      createProjetoArquivoUseCase,
      pushErrorNotification,
    ],
  );

  const handleDocumento = useCallback(() => {
    if (idProjeto > 0 || selectedProjeto) {
      setOpenDeleteModalDoc(false);
      setOpenModalDocumentos(true);
      setSelectedDocumento(null);
      let id = idProjeto > 0 ? idProjeto : selectedProjeto?.IdProjeto;
      hookFormDocumento.reset({
        idProjeto: id,
        descricao: "",
        idProjetoArquivo: 0,
        nome: "",
      });
    } else {
      setOpenDeleteModalDoc(false);
      setOpenModalDocumentos(false);
      return pushWarnNotification(
        "Atenção",
        "Salve um novo projeto para poder preencher o restante do formulário.!",
      );
    }
  }, [idProjeto, selectedProjeto, hookFormDocumento, pushWarnNotification]);

  const handleTableDocChange = useCallback(
    async (page: number) => {
      try {
        setLoading(true);
        paginationAnexarDocumentos.setPage(page + 1);
        await loadAnexarDocumentos({ IdProjeto: idProjeto, Page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      idProjeto,
      loadAnexarDocumentos,
      paginationAnexarDocumentos,
      pushErrorNotification,
    ],
  );

  const handleRowsPerTableDocChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        setLoading(true);
        paginationAnexarDocumentos.setPage(1);
        paginationAnexarDocumentos.setRowsPerPage(rowsPerPage);

        await loadAnexarDocumentos({
          IdProjeto: idProjeto,
          Page: 1,
          RowsPerPage: rowsPerPage,
        });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      idProjeto,
      loadAnexarDocumentos,
      paginationAnexarDocumentos,
      pushErrorNotification,
    ],
  );

  //#region ARQUIVOS

  const handleDownload = useCallback(
    async (arquivoNome: string, arquivo: string) => {
      if (!saving) {
        try {
          await downloadBase64File(arquivoNome, arquivo);
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao fazer download do arquivo!"),
          );
        }
      }
    },
    [saving, pushErrorNotification],
  );

  const handleArquivoDeleteOpenState = useCallback(
    (
      limparArquivos: string | null,
      arquivo: string | null,
      openState: boolean,
    ) => {
      if (openState && limparArquivos && arquivo) {
        setOpenDeleteArquivoModal(openState);
        setLimparArquivo(limparArquivos);
        setArquivo(arquivo);
      } else {
        setOpenDeleteArquivoModal(openState);
        setLimparArquivo(undefined);
        setArquivo(undefined);
      }
    },
    [],
  );

  const handleDeleteFile = useCallback(
    (limparArquivos: string, arquivo: string) => {
      if (!saving) {
        hookFormDocumento.setValue(limparArquivos as any, true);
        hookFormDocumento.setValue(arquivo as any, null);

        setSelectedDocumento((prev) =>
          prev ? { ...prev, [arquivo]: null } : null,
        );

        if (limparArquivos === "Arquivo" || arquivo === "Arquivo") {
          hookFormDocumento.setValue("nome", "");
          hookFormDocumento.setValue("arquivo", undefined);
        }
      }
    },
    [hookFormDocumento, saving],
  );

  const handleConfirmarDeletarArquivo = useCallback(async () => {
    if (limparArquivo && arquivo) {
      handleDeleteFile(limparArquivo, arquivo);
      setOpenDeleteArquivoModal(false);
      setArquivo(undefined);
      setLimparArquivo(undefined);
    }
  }, [limparArquivo, arquivo, handleDeleteFile]);
  //#endregion

  function base64ToFile(base64: string, fileName: string, mimeType: string) {
    const byteString = atob(base64);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    return new File([uint8Array], fileName, { type: mimeType });
  }

  const handleEdicaoDocOpenState = useCallback(
    (Id: number | null, openState: boolean) => {
      if (openState && Id && arquivosLista) {
        setOpenModalDocumentos(true);
        const itemParaEditar = arquivosLista.find(
          (x) => x.IdProjetoArquivo === Id,
        );
        if (itemParaEditar) setSelectedDocumento(itemParaEditar);
      } else {
        hookFormDocumento.reset();
        setOpenModalDocumentos(false);
      }
    },
    [arquivosLista, hookFormDocumento],
  );

  const DeletarAnexarDocumentos = useCallback(async () => {
    try {
      setLoading(true);
      if (selectedDocumento) {
        await deleteProjetoArquivoUseCase.deleteProjetoArquivo(
          selectedDocumento.IdProjetoArquivo,
        );
        await loadAnexarDocumentos();
        pushInfoNotification("Sucesso", "Arquivo deletado com sucesso!", {
          isAutoFinish: true,
        });
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao excluir informações!"),
      );
    } finally {
      setLoading(false);
      setOpenDeleteModalDoc(false);
    }
  }, [
    selectedDocumento,
    deleteProjetoArquivoUseCase,
    loadAnexarDocumentos,
    pushInfoNotification,
    pushErrorNotification,
  ]);

  const DeleteOpenModalDocumentos = useCallback(
    (IdProjetoArquivo: number | null, openState: boolean) => {
      if (openState) {
        const deletar = arquivosLista.find(
          (x) => x.IdProjetoArquivo === IdProjetoArquivo,
        );
        if (deletar) setSelectedDocumento(deletar);
      }
      setOpenDeleteModalDoc(openState);
    },
    [arquivosLista],
  );

  const handleAnexarDocumentosDownload = useCallback(
    async (arquivoNome: string, arquivo: string) => {
      try {
        await downloadBase64File(arquivoNome, arquivo);
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao fazer download do arquivo!"),
        );
      }
    },
    [pushErrorNotification],
  );

  const handleAnexarDocumentosDownloadLista = useCallback(
    async (id: number, imageName: string) => {
      setCustomLoading(true);
      try {
        await getProjetoArquivoByIdUseCase.getProjetoArquivoById({
          id,
          imageName,
        });
        return setCustomLoading(false);
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao fazer download do arquivo!"),
        );
      }
    },
    [setCustomLoading, getProjetoArquivoByIdUseCase, pushErrorNotification],
  );

  const handleDownloadDisciplinaArquivosLista = useCallback(
    async (id: number, numero: number) => {
      try {
        const response =
          await getDisciplinasArquivosByIdUseCase.getDisciplinasArquivosById({
            id,
          });
        if (response) {
          if (numero === 1) {
            if (response.arquivo && response.nome) {
              await downloadBase64File(response.nome, response.arquivo);
            }
          } else {
            if (response.nome2 && response.arquivo2) {
              await downloadBase64File(response.nome2, response.arquivo2);
            }
          }
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao fazer download do arquivo!"),
        );
      }
    },
    [pushErrorNotification, getDisciplinasArquivosByIdUseCase],
  );

  //#endregion

  //#region Informacoes Projeto

  //#region Load
  const loadInformacoesProjeto = useCallback(
    async (funcState?: LoadInformacoesPorjetoFuncState) => {
      try {
        const filterInfromacoes = evaluateParamValue(
          funcState?.Informacoes,
          filtersInformacoes.Informacoes,
        );
        const filteredata = evaluateParamValue(
          funcState?.Data,
          filtersInformacoes.Data,
        );
        const filterIdProjeto = funcState?.IdProjeto ?? idProjeto;
        const filterpage = funcState?.Page ?? paginationInformacoes.page;
        const filterRowspage =
          funcState?.RowsPerPage ?? paginationInformacoes.rowsPerPage;

        await getAllProjetoInformacoesUseCase.getAllProjetoInformacoes(
          {
            IdProjeto: filterIdProjeto,
            DescInformacoes: filterInfromacoes ?? null,
            Data: filteredata ?? null,
          },
          filterpage,
          filterRowspage,
        );
        setInformacoesLista(getAllProjetoInformacoesUseCase.items);
        paginationInformacoes.setRowsPerPage(
          getAllProjetoInformacoesUseCase.pageSize,
        );
        paginationInformacoes.setTotalItems(
          getAllProjetoInformacoesUseCase.totalItems,
        );
      } catch (e: unknown) {
        setInformacoesLista([]);
        throw new Error("Falha ao buscar informações!");
      }
    },
    [
      filtersInformacoes.Informacoes,
      filtersInformacoes.Data,
      idProjeto,
      paginationInformacoes,
      getAllProjetoInformacoesUseCase,
    ],
  );
  //#endregion

  //#region Filter

  const handleInformacoesChange = useDebouncedCallback(
    debouncedLoad,
    (informacoes: string) => {
      useFiltersInformacoes.setState({ Informacoes: informacoes });
      return async () => {
        try {
          setLoading(true);
          useInformacoesProjetoPagination.setState({ page: 1 });
          await loadInformacoesProjeto({
            Page: 1,
            Informacoes: informacoes,
            IdProjeto: idProjeto,
          });
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao buscar dados da pagina!"),
          );
        } finally {
          setLoading(false);
        }
      };
    },
    [loadInformacoesProjeto, pushErrorNotification],
  );

  const handleDataChange = useDebouncedCallback(
    debouncedLoad,
    (data: Date | null) => {
      useFiltersInformacoes.setState({ Data: data });
      return async () => {
        try {
          setLoading(true);
          useInformacoesProjetoPagination.setState({ page: 1 });
          await loadInformacoesProjeto({
            Page: 1,
            Data: data,
            IdProjeto: idProjeto,
          });
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao buscar dados da pagina!"),
          );
        } finally {
          setLoading(false);
        }
      };
    },
    [loadInformacoesProjeto, pushErrorNotification],
  );

  const handleClear = useCallback(async () => {
    try {
      setLoading(true);
      useFiltersInformacoes.setState({ ...initialInformacoesFiltersState });
      useInformacoesProjetoPagination.setState({ page: 1 });
      await loadInformacoesProjeto({
        ...initialInformacoesFiltersState,
        Page: 1,
        IdProjeto: idProjeto,
      });
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao buscar dados da pagina!"),
      );
    } finally {
      setLoading(false);
    }
  }, [idProjeto, loadInformacoesProjeto, pushErrorNotification]);

  //#endregion

  //#region Evento

  const handleInforSubmit = useCallback(
    async (form: ProjetoInformacoesForm) => {
      try {
        setSaving(true);
        if (selectedInfo) {
          await updateProjetoInformacoesUseCase.updateProjetoInformacoes(
            selectedInfo.IdInformacoes,
            idProjeto,
            form.descInformacoes ?? null,
            form.idFuncionario ?? null,
            form.data ?? null,
          );
          pushInfoNotification(
            "Sucesso",
            "Informação atualizada com sucesso!",
            { isAutoFinish: true },
          );
        } else {
          await createProjetoInformacoesUseCase.createProjetoInformacoes(
            idProjeto,
            form.descInformacoes ?? null,
            form.idFuncionario ?? null,
            form.data ?? null,
          );
          pushInfoNotification("Sucesso", "Informação criada com sucesso!", {
            isAutoFinish: true,
          });
        }
        await loadInformacoesProjeto();
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar informações!"),
        );
      } finally {
        setSaving(false);
        setOpenModalInfor(false);
      }
    },
    [
      selectedInfo,
      loadInformacoesProjeto,
      updateProjetoInformacoesUseCase,
      idProjeto,
      pushInfoNotification,
      createProjetoInformacoesUseCase,
      pushErrorNotification,
    ],
  );

  const handleEdicaoInfoOpenState = useCallback(
    (Id: number | null, openState: boolean) => {
      if (openState && Id && informacoesLista) {
        setOpenModalInfor(true);
        const itemParaEditar = informacoesLista.find(
          (x) => x.IdInformacoes === Id,
        );
        if (itemParaEditar) setSelectedInfo(itemParaEditar);
      } else {
        hookFormInformacoes.reset();
        setOpenModalInfor(false);
      }
    },
    [hookFormInformacoes, informacoesLista],
  );

  const handleInfo = useCallback(() => {
    if (idProjeto > 0 || selectedInfo) {
      setOpenDeleteModalInfor(false);
      setOpenModalInfor(true);
      setSelectedInfo(null);
      let id = idProjeto > 0 ? idProjeto : selectedInfo?.IdProjeto;
      hookFormInformacoes.reset({
        idProjeto: id,
        data: new Date(),
        descInformacoes: "",
        idFuncionario: 0,
        idInformacoes: 0,
      });
    } else {
      setOpenDeleteModalDoc(false);
      setOpenModalDocumentos(false);
      return pushWarnNotification(
        "Atenção",
        "Salve um novo projeto para poder preencher o restante do formulário.",
      );
    }
  }, [idProjeto, selectedInfo, hookFormInformacoes, pushWarnNotification]);

  const DeleteOpenModalInfo = useCallback(
    (id: number | null, openState: boolean) => {
      if (openState) {
        const deletar = informacoesLista.find((x) => x.IdInformacoes === id);
        if (deletar) setSelectedInfo(deletar);
      }
      setOpenDeleteModalInfor(openState);
    },
    [informacoesLista],
  );
  const DeletarInfor = useCallback(async () => {
    try {
      setLoading(true);
      if (selectedInfo) {
        await deleteProjetoInformacoesUseCase.deleteProjetoInformacoes(
          selectedInfo.IdInformacoes,
        );
        await loadInformacoesProjeto();
        pushInfoNotification("Sucesso", "Informação deletada com sucesso!", {
          isAutoFinish: true,
        });
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao excluir informações!"),
      );
    } finally {
      setLoading(false);
      setOpenDeleteModalInfor(false);
    }
  }, [
    selectedInfo,
    deleteProjetoInformacoesUseCase,
    loadInformacoesProjeto,
    pushInfoNotification,
    pushErrorNotification,
  ]);

  //#endregion
  //#endregion

  //#region Disciplinas

  const loadRevisao = useCallback(
    async (funcState?: LoadRevisaoFuncState) => {
      try {
        const filterIdProjeto = funcState?.IdProjeto ?? idProjeto;
        const filterIdDisciplina = funcState?.idDisciplina ?? IdDisciplina;
        const filterpage = funcState?.Page ?? 1;
        const filterRowspage = funcState?.RowsPerPage ?? 100;

        await getAllProjetoRevisaoResumoUseCase.getAllProjetoRevisaoResumo(
          filterIdProjeto,
          filterIdDisciplina,
          filterpage,
          filterRowspage,
        );
        setRevisaoLista(getAllProjetoRevisaoResumoUseCase.items);
        paginationResumo.setRowsPerPage(
          getAllProjetoRevisaoResumoUseCase.pageSize,
        );
        paginationResumo.setTotalItems(
          getAllProjetoRevisaoResumoUseCase.totalItems,
        );
      } catch (e: unknown) {
        setArquivosLista([]);
        throw new Error("Falha ao buscar revisões!");
      }
    },
    [
      idProjeto,
      IdDisciplina,
      getAllProjetoRevisaoResumoUseCase,
      paginationResumo,
    ],
  );

  const loadDisciplinas = useCallback(
    async (funcState?: LoadProjetoDisciplinasFuncState) => {
      try {
        const filterDisciplinas = evaluateParamValue(
          funcState?.Disciplina,
          filterDisciplina.disciplina,
        );
        const filterPrancha = evaluateParamValue(
          funcState?.Prancha,
          filterDisciplina.prancha,
        );
        const filterRevisao = evaluateParamValue(
          funcState?.Revisao,
          filterDisciplina.revisao,
        );
        const filterPor = evaluateParamValue(
          funcState?.Por,
          filterDisciplina.por,
        );

        const filterIdProjeto = funcState?.IdProjeto ?? idProjeto;
        const filterPage = funcState?.Page ?? paginationDisciplinasProjeto.page;
        const filterRowsPage =
          funcState?.RowsPerPage ?? paginationDisciplinasProjeto.rowsPerPage;

        await getAllProjetoDisciplinaUseCase.getAllProjetoDisciplina(
          {
            IdProjeto: filterIdProjeto,
            Por: filterPor ?? "T",
            Disciplina: filterDisciplinas ?? undefined,
            Prancha: filterPrancha ?? undefined,
            Revisao: filterRevisao ?? undefined,
          },
          filterPage,
          filterRowsPage,
        );
        setDisciplinasLista(getAllProjetoDisciplinaUseCase.items);
        paginationDisciplinasProjeto.setRowsPerPage(
          getAllProjetoDisciplinaUseCase.pageSize,
        );
        paginationDisciplinasProjeto.setTotalItems(
          getAllProjetoDisciplinaUseCase.totalItems,
        );
      } catch (e: unknown) {
        setDisciplinasLista([]);
        throw new Error("Falha ao buscar disciplinas do projeto!");
      }
    },
    [
      paginationDisciplinasProjeto,
      getAllProjetoDisciplinaUseCase,
      setDisciplinasLista,
      idProjeto,
      filterDisciplina,
    ],
  );

  //#region Filter Disciplinas

  const handleRemoverChecklistOpenModal = useCallback(
    (id: number | null, openState: boolean) => {
      if (openState && id) {
        setSelectedIdDisciplinaCheck(id);
      } else {
        setSelectedIdDisciplinaCheck(undefined);
      }
      setOpenRemoveModalDisciplinaCheck(openState);
    },
    [],
  );

  const handleRemoverChecklist = useCallback(async () => {
    try {
      setLoading(true);
      if (selectedIdDisciplinaCheck) {
        await deleteDisciplinaChecklistUseCase.deleteDisciplinaChecklist(
          selectedIdDisciplinaCheck,
        );
        pushInfoNotification("Sucesso", "Checklist deletada com sucesso!", {
          isAutoFinish: true,
        });
        await loadDisciplinas({ IdProjeto: idProjeto });
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao excluir informações!"),
      );
    } finally {
      setLoading(false);
      setOpenRemoveModalDisciplinaCheck(false);
    }
  }, [
    selectedIdDisciplinaCheck,
    deleteDisciplinaChecklistUseCase,
    idProjeto,
    pushInfoNotification,
    loadDisciplinas,
    pushErrorNotification,
  ]);

  const handlePorChange = useCallback(
    (por: string | null) => {
      filterDisciplina.setPor(por ?? "T");
      loadDisciplinas({ Por: por ?? "T" });
      loadfilterDisciplinaArquivos({ Por: por ?? "T" });
    },
    [filterDisciplina, loadDisciplinas, loadfilterDisciplinaArquivos],
  );

  const handleDisciplinaChange = useDebouncedCallback(
    debouncedLoad,
    (disciplina: string) => {
      filterDisciplina.setDisciplina(disciplina);
      return async () => {
        try {
          await loadDisciplinas({ Disciplina: disciplina });
          await loadfilterDisciplinaArquivos({ Disciplina: disciplina });
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao buscar dados da pagina!"),
          );
        }
      };
    },
    [filterDisciplina, loadDisciplinas, loadfilterDisciplinaArquivos],
  );

  const handlePranchaChange = useDebouncedCallback(
    debouncedLoad,
    (prancha: string) => {
      filterDisciplina.setPrancha(prancha);
      return async () => {
        try {
          await loadDisciplinas({ Prancha: prancha });
          await loadfilterDisciplinaArquivos({ Prancha: prancha });
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao buscar dados da pagina!"),
          );
        }
      };
    },
    [filterDisciplina, loadDisciplinas, loadfilterDisciplinaArquivos],
  );

  const handleRevisaoChange = useDebouncedCallback(
    debouncedLoad,
    (revisao: string) => {
      filterDisciplina.setRevisao(revisao);
      return async () => {
        try {
          await loadDisciplinas({ Revisao: revisao });
          await loadfilterDisciplinaArquivos({ Revisao: revisao });
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao buscar dados da pagina!"),
          );
        }
      };
    },
    [filterDisciplina, loadDisciplinas, loadfilterDisciplinaArquivos],
  );
  const handleClearDisciplina = useCallback(async () => {
    try {
      setLoading(true);
      useFiltersDisciplinas.setState({ ...initialDisciplinasFiltersState });
      // useFiltersDisciplinasArquivos.setState({ page: 1 });
      await loadDisciplinas({
        Por: null,
        Disciplina: null,
        Prancha: null,
        Revisao: null,
        IdProjeto: idProjeto,
        Page: 1,
      });

      await loadfilterDisciplinaArquivos({
        Por: null,
        Disciplina: null,
        Prancha: null,
        Revisao: null,
        IdProjeto: idProjeto,
        Page: 1,
      });
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao buscar dados da pagina!"),
      );
    } finally {
      setLoading(false);
    }
  }, [
    idProjeto,
    loadDisciplinas,
    loadfilterDisciplinaArquivos,
    pushErrorNotification,
  ]);

  const handleDisciplinaSubmit = useCallback(
    async (form: DisciplinaRequestForm) => {
      try {
        setSaving(true);
        if (IdDisciplina && IdDisciplina > 0) {
          await updateProjetoDisciplinaUseCase.updateProjetoDisciplina(
            IdDisciplina,
            idProjeto ?? 0,
            form.idChecklist ?? null,
            form.tipo ?? null,
            form.descricao,
            form.idFuncionario ?? null,
            form.idFornecedor ?? null,
            form.descResponsavel ?? null,
            form.datainicioPrevisto ?? null,
            form.datainicioReal ?? null,
            form.datafimPrevisto ?? null,
            form.datafimReal ?? null,
            form.dataDisciplina ?? null,
            form.revisao ?? null,
            form.plantas ?? null,
            form.local1 ?? null,
            form.local2 ?? null,
            form.local3 ?? null,
            form.local4 ?? null,
            form.local5 ?? null,
            form.local6 ?? null,
            definirModelSubDisciplina,
            form.idDisciplinaPai ?? null,
            form.ultimaRevisao ?? null,
            null,
            form.idCliente ?? null,
            form.nCopia1 ?? null,
            form.nCopia2 ?? null,
            form.nCopia3 ?? null,
            form.nCopia4 ?? null,
            form.nCopia5 ?? null,
            form.nCopia6 ?? null,
          );
          pushInfoNotification(
            "Sucesso",
            "Disciplina atualizado com sucesso!",
            { isAutoFinish: true },
          );
        } else {
          const IdDisciplina =
            await createProjetoDisciplinaUseCase.createProjetoDisciplina(
              idProjeto ?? 0,
              form.idChecklist ?? null,
              form.tipo ?? null,
              form.descricao,
              form.idFuncionario ?? null,
              form.idFornecedor ?? null,
              form.descResponsavel ?? null,
              form.datainicioPrevisto ?? null,
              form.datainicioReal ?? null,
              form.datafimPrevisto ?? null,
              form.datafimReal ?? null,
              form.dataDisciplina ?? null,
              form.revisao ?? null,
              form.plantas ?? null,
              form.local1 ?? null,
              form.local2 ?? null,
              form.local3 ?? null,
              form.local4 ?? null,
              form.local5 ?? null,
              form.local6 ?? null,
              definirModelSubDisciplina,
              form.idDisciplinaPai ?? null,
              form.ultimaRevisao ?? null,
              null,
              form.idCliente ?? null,
              form.nCopia1 ?? null,
              form.nCopia2 ?? null,
              form.nCopia3 ?? null,
              form.nCopia4 ?? null,
              form.nCopia5 ?? null,
              form.nCopia6 ?? null,
            );
          setIdDisciplina(Number(IdDisciplina));
          pushInfoNotification("Sucesso", "Disciplina criado com sucesso!", {
            isAutoFinish: true,
          });
        }
        await loadDropDownChecklist();
        await loadDropDownDisciplina(Number(idProjeto));
        await loadRevisao({ idDisciplina: IdDisciplina, IdProjeto: idProjeto });
        await loadDisciplinas({ IdProjeto: idProjeto });
        await dropDownChecklist;
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar disciplina!"),
        );
      } finally {
        setSaving(false);
      }
    },
    [
      IdDisciplina,
      loadDropDownChecklist,
      loadDropDownDisciplina,
      idProjeto,
      loadRevisao,
      loadDisciplinas,
      dropDownChecklist,
      updateProjetoDisciplinaUseCase,
      definirModelSubDisciplina,
      pushInfoNotification,
      createProjetoDisciplinaUseCase,
      pushErrorNotification,
    ],
  );

  const handleEdicaoDisciplinaOpenState = useCallback(
    async (id: number | null, openState: boolean) => {
      setOpenModaDisciplina(openState);
      if (openState && id) {
        const itemParaEditar =
          await getProjetoDisciplinaByIdUseCase.getProjetoDisciplinaById({
            id,
          });
        if (itemParaEditar) {
          await loadRevisao({
            IdProjeto: idProjeto,
            idDisciplina: itemParaEditar.idDisciplina,
          });
          requestAnimationFrame(() => {
            setSelectedtDisciplina(itemParaEditar);
            setIdDisciplina(Number(itemParaEditar.idDisciplina));
            setDefinirModelSubDisciplina(
              itemParaEditar.idDisciplinaPai != null,
            );
          });
        }
      } else {
        hookFormDisciplina.reset();
      }
    },
    [
      getProjetoDisciplinaByIdUseCase,
      hookFormDisciplina,
      idProjeto,
      loadRevisao,
    ],
  );

  const handleDisciplina = useCallback(
    (sub: boolean) => {
      if (idProjeto > 0 || selectedProjeto) {
        // setOpenDeleteModalInfor(false);
        setRevisaoLista([]);
        setDefinirModelSubDisciplina(sub);

        setOpenModaDisciplina(true);
        setSelectedtDisciplina(null);
        setIdDisciplina(0);
        hookFormDisciplina.reset({
          idProjeto: idProjeto,
        });
      } else {
        // setOpenDeleteModalDoc(false);
        setDefinirModelSubDisciplina(false);
        setOpenModaDisciplina(false);
        setRevisaoLista([]);
        setSelectedtDisciplina(null);
        setIdDisciplina(0);
        return pushWarnNotification(
          "Atenção",
          "Salve um novo projeto para poder preencher o restante do formulário.!",
        );
      }
    },
    [idProjeto, selectedProjeto, hookFormDisciplina, pushWarnNotification],
  );

  //#endregion

  //#region Delete Disciplina

  const DeletarDisciplina = useCallback(async () => {
    setLoading(true);

    if (IdDisciplina === undefined) return;
    try {
      await deleteProjetoDisciplinaUseCase.deleteProjetoDisciplina({
        id: IdDisciplina,
      });
      await loadDisciplinas();
    } catch (e: unknown) {
      const raw: string | string[] = processError(
        e,
        "Falha ao buscar dados da página!",
      );
      const msg = Array.isArray(raw)
        ? raw.join("\u000A")
        : (raw as string).replace(/\n/g, "\u000A");

      pushErrorNotification("Erro", msg);
    } finally {
      setLoading(false);
      setOpenDeleteModalDisciplina(false);
    }
  }, [
    IdDisciplina,
    deleteProjetoDisciplinaUseCase,
    loadDisciplinas,
    pushErrorNotification,
  ]);

  const DeleteOpenModalDisciplina = useCallback(
    (id: number | null, openState: boolean) => {
      if (openState) {
        if (id != null) {
          setIdDisciplina(id);
        } else {
          setIdDisciplina(0);
        }
      }
      setOpenDeleteModalDisciplina(openState);
    },
    [setIdDisciplina],
  );
  //#endregion

  const handleCopiaOpenState = useCallback(
    (IdDisciplina: number | null, openState: boolean) => {
      if (openState) {
        const disciplinaEncontrada =
          disciplinasLista.find((x) => x.IdDisciplina === IdDisciplina) || null;

        setSelectedtDisciplina(
          disciplinaEncontrada as unknown as GetProjetoDisciplinaByIdResponseModel | null,
        );
        setOpenCopiaModal(true);
      } else {
        setOpenCopiaModal(false);
      }
    },
    [disciplinasLista],
  );
  const handleViewChecklist = useCallback(
    (idChecklist: number | null) => {
      navigate(
        `/CronogramaItensChecklist_cadastro/${idChecklist}/${idProjeto}`,
      );
    },
    [idProjeto, navigate],
  );
  const handleVoltar = useCallback(() => {
    navigate(`/Projetos_lista`);
  }, [navigate]);

  //#endregion

  //#region ARQUIVOS

  const handlefecharmodelDicilinaArquivos = useCallback(() => {
    setOpenModaDisciplinaArquivo(false);
    setDadosEditDisciplinaArquivo(null);
  }, [setOpenModaDisciplinaArquivo, setDadosEditDisciplinaArquivo]);
  //#region GetById Arquivos

  const getbyIdDisciplinaArquivos = useCallback(
    async (id: number | null) => {
      setLoading(true);

      try {
        if (id != null) {
          const response =
            await getDisciplinasArquivosByIdUseCase.getDisciplinasArquivosById({
              id,
            });
          let arquivo: File | undefined = undefined;
          if (response.arquivo) {
            const mimeType = "application/octet-stream";
            arquivo = base64ToFile(
              response.arquivo,
              response.nome || "arquivo",
              mimeType,
            );
          }
          let arquivo2: File | undefined = undefined;
          if (response.arquivo2) {
            const mimeType = "application/octet-stream";
            arquivo2 = base64ToFile(
              response.arquivo2,
              response.nome2 || "arquivo2",
              mimeType,
            );
          }
          setDadosEditDisciplinaArquivo({
            ...response,
            arquivo,
            arquivo2,
          } as unknown as DisciplinaArquivoForm);
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar documento!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [getDisciplinasArquivosByIdUseCase, pushErrorNotification],
  );

  const handleEditDisciplinaArquivoOpenState = useCallback(
    async (idChecklist: number | null, openState: boolean) => {
      if (openState) {
        await getbyIdDisciplinaArquivos(idChecklist);
        setIdDisciplinaArquivos(idChecklist);
        setOpenModaDisciplinaArquivo(true);
      }
    },
    [
      getbyIdDisciplinaArquivos,
      setOpenModaDisciplinaArquivo,
      setIdDisciplinaArquivos,
    ],
  );

  //#endregion

  //#region Update Disciplina Arquivos
  const handleDisciplinaArquivoSubmit = useCallback(
    async (form: DisciplinaArquivoForm) => {
      try {
        setLoading(true);
        setSaving(true);
        await updateDisciplinasArquivosUseCase.updateDisciplinasArquivos({
          idDisciplina: IdDisciplinaArquivos ?? 0,
          arquivo: form.arquivo ?? undefined,
          arquivo2: form.arquivo2 ?? undefined,
          nome: form.nome ?? undefined,
          nome2: form.nome2 ?? undefined,
          limparArquivo: form.limparArquivo1,
          limparArquivo2: form.limparArquivo2,
        });

        await loadfilterDisciplinaArquivos();
      } catch (e: unknown) {
        setSaving(false);
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar arquivos da disciplina!"),
        );
      } finally {
        setSaving(false);
        setLoading(false);
        setOpenModaDisciplinaArquivo(false);
        pushInfoNotification(
          "Sucesso",
          "Disciplina arquivo atualizado com sucesso!",
          { isAutoFinish: true },
        );
      }
    },
    [
      IdDisciplinaArquivos,
      loadfilterDisciplinaArquivos,
      pushErrorNotification,
      pushInfoNotification,
      updateDisciplinasArquivosUseCase,
    ],
  );
  //#endregion

  //#region Delete Disciplina Arquivos
  const DeletarDisciplinaArquivo = useCallback(async () => {
    setLoading(true);

    if (IdDisciplinaArquivos === undefined) return;
    try {
      await deleteDisciplinasArquivosUseCase.deleteDisciplinasArquivos({
        id: IdDisciplinaArquivos ?? 0,
      });
      await loadfilterDisciplinaArquivos();
      pushInfoNotification(
        "Sucesso",
        "Disciplina arquivo deletado com sucesso!",
        { isAutoFinish: true },
      );
    } catch (e: unknown) {
      const raw: string | string[] = processError(
        e,
        "Falha ao buscar dados da página!",
      );
      const msg = Array.isArray(raw)
        ? raw.join("\u000A")
        : (raw as string).replace(/\n/g, "\u000A");

      pushErrorNotification("Erro", msg);
    } finally {
      setLoading(false);
      setOpenDeleteModalDisciplinaArquivo(false);
    }
  }, [
    IdDisciplinaArquivos,
    deleteDisciplinasArquivosUseCase,
    loadfilterDisciplinaArquivos,
    pushErrorNotification,
    pushInfoNotification,
  ]);

  const DeleteOpenModalDisciplinaArquivo = useCallback(
    (id: number | null, openState: boolean) => {
      if (openState) {
        if (id != null) {
          setIdDisciplinaArquivos(id);
        } else {
          setIdDisciplinaArquivos(null);
        }
      }
      setOpenDeleteModalDisciplinaArquivo(openState);
    },
    [setIdDisciplinaArquivos],
  );
  //#endregion
  //#endregion

  //#region useEffect
  const fetchTabData = useCallback(
    async (tabToLoad: string | number) => {
      if (!id) return;

      try {
        setLoading(true);
        const targetTab = String(tabToLoad);

        if (targetTab === "2") {
          await Promise.all([
            loadDisciplinas({ IdProjeto: Number(id) }),
            loadDropDownChecklist(),
            loadDropDownDisciplina(Number(id)),
          ]);
        } else if (targetTab === "3") {
          await loadfilterDisciplinaArquivos({ IdProjeto: Number(id) });
        } else {
          await Promise.all([
            LoadProjeto({ IdProjeto: Number(id) }),
            loadAnexarDocumentos({ IdProjeto: Number(id) }),
            loadInformacoesProjeto({ IdProjeto: Number(id) }),
          ]);
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da aba selecionada!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      id,
      LoadProjeto,
      loadAnexarDocumentos,
      loadDisciplinas,
      loadDropDownChecklist,
      loadDropDownDisciplina,
      loadInformacoesProjeto,
      loadfilterDisciplinaArquivos,
      pushErrorNotification,
    ],
  );

  usePageStartBootstrap(async () => {
    try {
      if (id) {
        setIdProjeto(Number(id));

        const initialTab = tab ? String(tab) : "1";
        if (tab) setCurrentTab(Number(initialTab));

        await fetchTabData(initialTab);
      }
    } catch (e: unknown) {
      setErrorMessage(processError(e, "Falha ao iniciar a página!")[0]);
    }
  });

  const handleReload = useCallback(async () => {
    const activeTab = currentTab || tab || "1";
    await fetchTabData(activeTab);
  }, [fetchTabData, currentTab, tab]);

  //#endregion

  const handleTabChange = useCallback(
    (_: React.SyntheticEvent, newValue: number) => {
      setCurrentTab(newValue);
      fetchTabData(newValue);
    },
    [fetchTabData],
  );

  //#region Revisao

  const handleRevisao = useCallback(async () => {
    if (IdDisciplina > 0 || selectedtDisciplina) {
      setOpenModalRevisao(true);
      setSelectedRevisao(undefined);
      let id =
        IdDisciplina > 0 ? IdDisciplina : selectedtDisciplina?.idDisciplina;
      hookFormRevisao.reset({
        idDisciplina: id,
      });
    } else {
      setOpenModalRevisao(false);
      return pushWarnNotification(
        "Atenção",
        "Você precisa salvar uma disciplina!",
      );
    }
  }, [
    IdDisciplina,
    hookFormRevisao,
    pushWarnNotification,
    selectedtDisciplina,
  ]);

  const handleRevisaoSubmit = useCallback(
    async (form: ProjetoRevisaoResumoForm) => {
      try {
        try {
          if (idProjeto && idProjeto > 0) {
            if (selectedRevisao && selectedRevisao.idProjetoRevisaoResumo) {
              await updateProjetoRevisaoResumoUseCase.updateProjetoRevisaoResumo(
                selectedRevisao.idProjetoRevisaoResumo,
                idProjeto,
                form.idDisciplina ?? null,
                form.descricao ?? null,
                form.responsavel ?? null,
                form.idFuncionario ?? null,
                form.data ?? null,
              );
              setOpenModalRevisao(false);
            } else {
              await createProjetoRevisaoResumoUseCase.createProjetoRevisaoResumo(
                idProjeto,
                form.idDisciplina ?? null,
                form.descricao ?? null,
                form.responsavel ?? null,
                form.idFuncionario ?? null,
                form.data ?? null,
              );
              pushInfoNotification("Sucesso", "Revisão criada com sucesso!", {
                isAutoFinish: true,
              });
              setOpenModalRevisao(false);
            }
          }
        } catch (e) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao criar Revisão!"),
          );
        } finally {
          setSaving(false);
        }
      } catch (e) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao criar Revisão!"),
        );
      } finally {
        setSaving(false);
        await loadRevisao({ IdProjeto: idProjeto, idDisciplina: IdDisciplina });
      }
    },
    [
      createProjetoRevisaoResumoUseCase,
      idProjeto,
      pushErrorNotification,
      pushInfoNotification,
      selectedRevisao,
      updateProjetoRevisaoResumoUseCase,
      loadRevisao,
      IdDisciplina,
    ],
  );

  const handleEdicaoRevisaoOpenState = useCallback(
    (Id: number | null, openState: boolean) => {
      if (openState && Id && revisaoLista) {
        setOpenModalRevisao(true);
        const itemParaEditar = revisaoLista.find(
          (x) => x.idProjetoRevisaoResumo === Id,
        );
        if (itemParaEditar) setSelectedRevisao(itemParaEditar);
      } else {
        hookFormInformacoes.reset();
        setOpenModalRevisao(false);
      }
    },
    [hookFormInformacoes, revisaoLista],
  );

  const DeleteOpenModalRevisao = useCallback(
    (id: number | null, openState: boolean) => {
      if (openState) {
        const deletar = revisaoLista.find(
          (x) => x.idProjetoRevisaoResumo === id,
        );
        if (deletar) setSelectedRevisao(deletar);
      }
      setOpenDeleteModalRevisao(openState);
    },
    [revisaoLista],
  );

  const DeletarRevisao = useCallback(async () => {
    try {
      setLoading(true);
      if (selectedRevisao) {
        await deleteProjetoRevisaoResumoUseCase.deleteProjetoRevisaoResumo(
          selectedRevisao.idProjetoRevisaoResumo,
        );
        await loadRevisao({ IdProjeto: idProjeto, idDisciplina: IdDisciplina });
        pushInfoNotification("Sucesso", "Revisão deletada com sucesso!", {
          isAutoFinish: true,
        });
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao excluir revisão!"),
      );
    } finally {
      setLoading(false);
      setOpenDeleteModalRevisao(false);
    }
  }, [
    selectedRevisao,
    deleteProjetoRevisaoResumoUseCase,
    loadRevisao,
    idProjeto,
    IdDisciplina,
    pushInfoNotification,
    pushErrorNotification,
  ]);

  const handleTableRevisaoChange = useCallback(
    async (page: number) => {
      try {
        setLoading(true);
        paginationResumo.setPage(page + 1);
        await loadRevisao({
          IdProjeto: idProjeto,
          idDisciplina: IdDisciplina,
          Page: page + 1,
        });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      IdDisciplina,
      idProjeto,
      loadRevisao,
      paginationResumo,
      pushErrorNotification,
    ],
  );

  const handleRowsPerTableRevisaoChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        setLoading(true);
        paginationResumo.setPage(1);
        paginationResumo.setRowsPerPage(rowsPerPage);
        await loadRevisao({
          IdProjeto: idProjeto,
          idDisciplina: IdDisciplina,
          Page: rowsPerPage + 1,
        });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      IdDisciplina,
      idProjeto,
      loadRevisao,
      paginationResumo,
      pushErrorNotification,
    ],
  );

  //#endregion

  //#region  Historico

  const handleOpenChangeHistory = useCallback(
    (idTabela: number | null, tipoTabela: LogTipoTabela | null) => {
      if (idTabela && tipoTabela) {
        changeHistory.handleOpenChangeHistory(idTabela, tipoTabela, false);
      } else {
        if (idProjeto) {
          changeHistory.handleOpenChangeHistory(
            idProjeto,
            LogTipoTabela.PROJETO,
            true,
          );
        }
      }
    },
    [changeHistory, idProjeto],
  );

  //#endregion

  const handleSubmitCopiaDisciplina = useCallback(
    async (form: DisciplinaCopiaRequestForm) => {
      try {
        if (selectedtDisciplina) {
          const payload = {
            ...form,
          };
          setSaving(true);
          await copiaDisciplinasUseCase.copiaDisciplinas(payload);
          await loadDisciplinas();
          await loadDropDownDisciplina(Number(idProjeto));
          pushInfoNotification("Sucesso", "Disciplina copiada com sucesso!", {
            isAutoFinish: true,
          });
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao copiar Disciplina!"),
        );
      } finally {
        setOpenCopiaModal(false);
        setSaving(false);
      }
    },
    [
      selectedtDisciplina,
      copiaDisciplinasUseCase,
      loadDisciplinas,
      loadDropDownDisciplina,
      idProjeto,
      pushInfoNotification,
      pushErrorNotification,
    ],
  );

  const handleDownloadFile = useCallback(
    async (
      filename: string,
      imagePosition: number,
      idDisciplinaArquivo: number,
    ) => {
      if (idDisciplinaArquivo) {
        try {
          setLoading(true);

          await getArqDisciplinasArquivosUseCase.getArquivo(
            Number(idDisciplinaArquivo),
            imagePosition,
            filename,
          );
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao salvar inspeção obra!"),
          );
        } finally {
          setLoading(false);
        }
      }
    },
    [getArqDisciplinasArquivosUseCase, pushErrorNotification],
  );

  //#region Relatorio
  const handleSubmitReport = useCallback(async () => {
    try {
      setLoading(true);

      await startReportViewerProcess({
        fetchCallback: async (requiredMimeType) =>
          await getReportListaDisciplinasUseCase.getReportListaDisciplinas(
            requiredMimeType,
            idProjeto,
          ),
        closeReportModalCallback: () => {
          // setOpenReportModal(false);
        },
      });
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao gerar relatorio"),
      );
    } finally {
      setLoading(false);
    }
  }, [
    getReportListaDisciplinasUseCase,
    idProjeto,
    pushErrorNotification,
    startReportViewerProcess,
  ]);

  const handleSubmitReportPlanoProjeto = useCallback(async () => {
    try {
      setLoading(true);
      await startReportViewerProcess({
        fetchCallback: async (requiredMimeType) =>
          await getReportPlanoProjetoUseCase.getReportPlanoProjeto(
            requiredMimeType,
            idProjeto,
          ),
        closeReportModalCallback: () => {
          // setOpenReportModal(false);
        },
      });
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao gerar relatorio"),
      );
    } finally {
      setLoading(false);
    }
  }, [
    getReportPlanoProjetoUseCase,
    idProjeto,
    pushErrorNotification,
    startReportViewerProcess,
  ]);

  const opcoesRelatorio = [
    { id: 1, label: "Plano de Projeto" },
    { id: 2, label: "Lista de Controle" },
  ];

  const handleSelecionarRelatorio = useCallback(
    (itemSelecionado: any) => {
      if (itemSelecionado === 1) {
        handleSubmitReportPlanoProjeto();
      } else if (itemSelecionado === 2) {
        handleSubmitReport();
      }
    },
    [handleSubmitReport, handleSubmitReportPlanoProjeto],
  );
  //#endregion

  return {
    disciplinasListaArquivos,
    currentTab,
    arquivosLista,
    informacoesLista,
    paginationAnexarDocumentos,
    paginationInformacoes,
    loading,
    openDeleteModalDoc,
    openDeleteModalInfor,
    openModalInfor,
    filtersInformacoes,
    disciplinasLista,
    paginationDisciplinasProjeto,
    filterDisciplina,
    definirModelSubDisciplina,
    hookFormDisciplina,
    openModalDisciplina,
    dropDownChecklist,
    dropDownDisciplina,
    openDeleteModalDisciplina,
    abrirModalDisciplinaArquivo,
    dadosEditDisciplinaArquivo,
    openDeleteModalDisciplinaArquivo,
    saving,
    hookForm,
    hookFormDocumento,
    hookFormInformacoes,
    selectedProjeto,
    openModalDocumentos,
    selectedDocumento,
    openDeleteArquivoModal,
    selectedInfo,
    openRemoveModalDisciplinaCheck,
    selectedtDisciplina,
    openModalRevisao,
    IdDisciplina,
    selectedRevisao,
    revisaoLista,
    paginationResumo,
    openDeleteModalRevisao,
    changeHistory,
    idProjeto,
    openCopiaModal,
    reportViewerState,
    nomeCentroCusto,
    opcoesRelatorio,
    handleDownloadFile,
    handleAnexarDocumentosDownloadLista,
    handleDownloadDisciplinaArquivosLista,
    setOpenDeleteModalRevisao,
    handleEdicaoRevisaoOpenState,
    setOpenModalRevisao,
    setOpenModaDisciplina,
    handleRemoverChecklistOpenModal,
    setOpenModalInfor,
    handleRemoverChecklist,
    handleInfo,
    setOpenDeleteArquivoModal,
    handleReload,
    handleProjetoSubmit,
    setOpenModalDocumentos,
    handleaDocumentoSubmit,
    handleDocumento,
    handleEdicaoDocOpenState,
    DeletarAnexarDocumentos,
    DeleteOpenModalDocumentos,
    handleAnexarDocumentosDownload,
    handleInforSubmit,
    handleEdicaoInfoOpenState,
    DeletarInfor,
    DeleteOpenModalInfo,
    handleInformacoesChange,
    handleClear,
    handleDataChange,
    handleTabChange,
    handleViewChecklist,
    handleRevisao,
    handlePorChange,
    handleDisciplinaChange,
    handlePranchaChange,
    handleRevisaoChange,
    handleClearDisciplina,
    handleDisciplinaSubmit,
    handleDisciplina,
    handleEdicaoDisciplinaOpenState,
    DeletarDisciplina,
    DeleteOpenModalDisciplina,
    handleEditDisciplinaArquivoOpenState,
    handlefecharmodelDicilinaArquivos,
    handleDisciplinaArquivoSubmit,
    handleRevisaoSubmit,
    DeleteOpenModalDisciplinaArquivo,
    DeletarDisciplinaArquivo,
    handleConfirmarDeletarArquivo,
    handleDeleteFile,
    handleArquivoDeleteOpenState,
    handleDownload,
    handleOpenChangeHistory,
    handleRowsPerTableDocChange,
    handleTableDocChange,
    handleRowsPerTableRevisaoChange,
    handleTableRevisaoChange,
    DeletarRevisao,
    DeleteOpenModalRevisao,
    handleVoltar,
    handleCopiaOpenState,
    handleSubmitCopiaDisciplina,
    handleSubmitReport,
    handleSubmitReportPlanoProjeto,
    handleSelecionarRelatorio,
  };
};
